import isMobile from 'ismobilejs'
import API from '@/api'
import NotFoundModule from '@/components/not-found-module/index'
import Mobile from './mobile'
import fontSizeMixin from '@/common/js/font-size-mixin'
import initMixin from '@/common/js/init-mixin'
import './index.styl'

const PC_REDIRECT_URL = 'http://www.shenhudong.com/module_pc/indexMini.php?type=1&id='

export default {
  mixins: [fontSizeMixin, initMixin],
  components: {
    NotFoundModule,
    Mobile
  },
  data() {
    return {
      checked: false,
      homePage: {},
      searchValue:'',
      list: [],
      navId: null
    }
  },
  async mounted() {
    // 非移动端 跳转至 PC 端引导页面
    const isMobileDevice = new isMobile.Class(window.navigator.userAgent).any
    if (!isMobileDevice) {
      return window.location.replace(PC_REDIRECT_URL + this.$route.params.orgId)
    }

    this.windowResizeHandler()
    window.addEventListener('resize', this.windowResizeHandler)
    this.getTokenFromUrl()
    try {
      await this.getWebUrl()
    } catch (err) {
      return
    }
    
    // get config
    await this.getConfig()
    this.checked = true

    /* eslint-disable-next-line */
    const { sharef, sharef_title, sharef_content, sharef_img } = this.homePage
    this.setConfig().then(() => {
      if (parseInt(sharef)) {
        const link = window.location.origin + window.location.pathname
        this.$wx.shareWithFriend({
          title: sharef_title,
          desc: sharef_content,
          link,
          imgUrl: sharef_img
        })
        this.$wx.shareTimeline({
          title: sharef_title,
          link,
          imgUrl: sharef_img
        })
      } else {
        this.$wx.hideOptionMenu()
      }
    })
  },
  methods: {
    initNav(){
      this.navId = -1
      this.getConfig()
    },
    handleChangeInputValue(val) {
      this.searchValue = val
    },
    handleSearchCancel() {
      this.searchValue = ''
      this.$nextTick(() => {
        this.getConfig()
      })
    },
    handleSearchSubmit() {
      this.getConfig()
      document.activeElement.blur();
    },
    mobileClickNav({id, index}) {
      this.navId = id
      this.getConfig()
    },
    async getConfig() {
      let resp
      try {
        this.$vux.loading.show({ text: '加载中' })
        const baseUrl = API.common.getOrgConfig + '/' + this.$route.params.orgId
        const url = this.navId ? baseUrl + '/nav/' + this.navId : baseUrl
        resp = await this.$http({
          method: 'POST',
          url,
          params: {
            token: this.$storage.getItem('token'),
            search: this.searchValue,
            openid: this.$storage.getItem('openid'),
          }
        })
        if (!resp) {
          this.isNotFound = true
          return false
        }
        this.homePage = resp.homepage
        this.list = resp.list
      } catch (error) {
        this.isNotFound = true
        console.error(error)
      } finally {
        this.$vux.loading.hide()
      }
    }
  },
  render() {
    if (this.checked) {
      // 404
      if (this.isNotFound) {
        return <NotFoundModule />
      }
      return (
        <div style={(parseInt(this.homePage.user_id) === 431555) ? 'padding-bottom: 4.4rem;min-height:100%' : ''}>
          {
            +this.homePage.user_id === 431555 && [
              <x-sticky className="search-input" scroll-box="group-title">
                <x-search
                  placeholder="按活动名称/地址搜索"
                  auto-fixed={false}
                  onInput={this.handleChangeInputValue}
                  value={this.searchValue}
                  onOn-submit={this.handleSearchSubmit}
                  onOn-cancel={this.handleSearchCancel}
                />
              </x-sticky>
            ]
          }
          <Mobile
            onMobileClickNav={this.mobileClickNav}
            homePage={this.homePage}
            list={this.list} />
          {
            +this.homePage.user_id === 431555 && [
              <div style="width: 100%;position: fixed;bottom: 0;left: 0;background-color: rgb(206 24 30);height: 4.4rem;"><img onClick={this.initNav} src="https://image.wxopen.shenhudong.com/431555/431555_bottom.png" style="width: 70%;position: fixed;bottom: 0;left: 15%;"/></div>
            ]
          }
        </div>
      )
    }
  }
}